import { PureComponent } from 'react';
import type { ECGClientProps } from './ecgClient.types';

/**
 * Pass-through container hosting the ECG viewer's contents inside the widget tree. Extends PureComponent so it only re-renders when its props change, and renders a plain div wrapping the children.
 */
class ECGClient extends PureComponent<ECGClientProps> {
  /**
   * Renders the ECG client container. Reads children off the props and returns them wrapped in a div.
   *
   * @returns The wrapping div element.
   */
  render() {
    const { children } = this.props;
    return <div>{children}</div>;
  }
}

(ECGClient as any).defaultProps = {
  children: {},
};

export default ECGClient;
